import { useEffect, useState } from "react";
import { getExpeditionIdentifier } from "@/lib/expedition.util";
import { ExpeditionFormProps } from "./expeditionForm.types";
import { CustomQuotationExpeditionFormStepOne } from "./customQuotationExpeditionForm/customQuotationExpeditionFormStepOne";
import { CustomQuotationExpeditionFormStepTwo } from "./customQuotationExpeditionForm/customQuotationExpeditionFormStepTwo";
import { FinalizeApi } from "@/types/finalizeApi.type";

export const CustomQuotationExpeditionForm = ({
  expedition,
  company,
  apiEnum,
}: ExpeditionFormProps) => {
  const expeditionIdentifier = getExpeditionIdentifier(expedition);

  const [formStep, setFormStep] = useState(expedition.finalizeIndex);
  const [selectedApiEnum, setSelectedApiEnum] = useState<FinalizeApi>(apiEnum);

  useEffect(() => {
    if (formStep === 1) {
      setSelectedApiEnum(apiEnum);
    }
  }, [apiEnum, formStep]);

  useEffect(() => {
    const defaultTitle = "Pelican Air Services";
    if (expeditionIdentifier) {
      document.title = `${expeditionIdentifier} - ${formStep}/2`;
    }
    return () => {
      document.title = defaultTitle;
    };
  }, [expeditionIdentifier, formStep]);

  if (formStep === 1) {
    return (
      <CustomQuotationExpeditionFormStepOne
        expedition={expedition}
        company={company}
        apiEnum={apiEnum}
        formStep={formStep}
        setFormStep={setFormStep}
        onApiEnumConfirmed={setSelectedApiEnum}
      />
    );
  }

  return (
    <CustomQuotationExpeditionFormStepTwo
      expedition={expedition}
      apiEnum={selectedApiEnum}
      formStep={formStep}
      setFormStep={setFormStep}
      company={company}
    />
  );
};
